import styled from 'styled-components/macro';
import { deviceMax } from 'utils/styles/breakpoints';
import { FONT_FAMILY, FONTS } from 'utils/styles/fonts';
import { COLORS } from 'utils/styles/colors';
import { FLEX_CONTAINER } from 'utils/styles/flex';

export const InputBlock = styled.div`
  position: relative;
  margin-top: 40px;
  width: 250px;
`;

export const StyledInput = styled.input`
  ${FONTS.font16}
  width: 100%;
  ${FLEX_CONTAINER.Unset}
  height: 36px;
  background: none;
  border-bottom: ${({ error }) =>
    error ? `1px solid ${COLORS.red}` : `1px solid ${COLORS.mainColor}`};
  color: ${({ error }) => (error ? `${COLORS.red}` : `${COLORS.mainColor}`)};

  &::placeholder {
    ${FONTS.font16}
    ${FLEX_CONTAINER.FlexRow};
    ${FONT_FAMILY.FontLight};
    color: ${({ error }) => (error ? `${COLORS.red}` : `${COLORS.mainColor}`)};
  }

  @media only screen and ${deviceMax.mobileL} {
    &::placeholder {
      ${FONTS.font12}
    }
  }
`;

export const PasswordVisibleIcon = styled.img`
  position: absolute;
  right: 0px;
  top: 12px;
  width: 26px;
  cursor: pointer;

  @media only screen and ${deviceMax.desktop} {
    width: 20px;
    right: 0px;
    cursor: pointer;
  }

  @media only screen and ${deviceMax.mobileL} {
    width: 16px;
  }
`;
export const ErrorMessage = styled.p`
  ${FONT_FAMILY.FontRegular};
  ${FONTS.font12};
  color: ${COLORS.red};
  padding-top: 4px;
  height: 14px;
`;
